import { useActiveDeal } from '@order/hooks/useDeal'
import AppConfig from 'config'
import { useMemo } from 'react'
import { resolveDevToggle, useDevToggles } from './dev/useDevToggles'
import { useConfigConditionGroupCheck } from 'features/config/useConfigCondition'
import { useConfigConditionValue } from 'features/config/useConfigConditionValue'

type IntroType = 'tiles:sv' | 'tiles:vf' | 'deals'

export type AppModes = {
  intro: IntroType
  isTgbo: boolean
  isAvatar: boolean
}

const useAppModes = (): AppModes => {
  const activeDeal = useActiveDeal()
  const devToggles = useDevToggles()

  const checkGroup = useConfigConditionGroupCheck()

  const introType = useMemo(() => {
    const checked = checkGroup('intro:type')
    return checked.valid[0]?.name
  }, [checkGroup])

  const introValue = useConfigConditionValue(introType, 'introType')

  return useMemo(() => {
    const isTgbo =
      activeDeal?.type === 'tgbo' ||
      (AppConfig.dealTypes.length === 1 && AppConfig.dealTypes[0] === 'tgbo')
    return {
      intro: introValue?.type ?? 'deals',
      isTgbo,
      isAvatar: !!resolveDevToggle(devToggles.avatar, false),
    }
  }, [activeDeal, devToggles, introValue])
}

type AppModeSetting = {
  modeName?: string
  preferPackageColor?: boolean
}

const AppModeSettings: Record<string, AppModeSetting> = {
  tgbo: {
    modeName: 'tgbo',
    preferPackageColor: true,
  },
} as const

export const useAppModeSettings = () => {
  const { isTgbo } = useAppModes()

  if (isTgbo) {
    return AppModeSettings.tgbo
  }

  return {} satisfies AppModeSetting
}

export default useAppModes
